import React from "react";
import { CheckCircle2, ExternalLink, ClipboardList, IndianRupee, FileCheck, User, ShieldCheck } from "lucide-react";
import TiltCard from "../components/TiltCard";
import PageBanner, { SectionTitle } from "../components/PageBanner";
import Countdown from "../components/Countdown";
import { colleges, pageBanners } from "../data/mock";

export default function Admissions() {
  const steps = [
    { icon: User, title: "Select College", desc: "Choose your allotted medical college." },
    { icon: ClipboardList, title: "Enter Details", desc: "Complete the secure registration form." },
    { icon: ShieldCheck, title: "College Validation", desc: "Confirm the allotted college before fee payment." },
    { icon: IndianRupee, title: "Pay Fee", desc: "Use the college payment link." },
    { icon: FileCheck, title: "Confirmation", desc: "Retain the acknowledgement for reporting." },
  ];

  return (
    <div className="page-enter">
      <PageBanner image={pageBanners.admissions} title="Student Registration" subtitle="Academic Year 2026-27 · Select your allotted college below. Registration and fee payment are completed on our secure partner portal in a new tab." />

      <section style={{ padding: "40px 24px 0" }}>
        <div style={{ maxWidth: 1300, margin: "0 auto", display: "flex", justifyContent: "center" }}>
          <Countdown size="large" />
        </div>
      </section>

      <section style={{ padding: "40px 24px 40px" }}>
        <div style={{ maxWidth: 1300, margin: "0 auto" }}>
          <SectionTitle>Registration Process</SectionTitle>
          <div className="grid-eq grid-5" style={{ display: "grid", gap: 18 }}>
            {steps.map((s, i) => (
              <TiltCard key={i} intensity={4} className="reg-step">
                <div className="reg-step-body">
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
                    <div style={{ width: 34, height: 34, borderRadius: "50%", background: "linear-gradient(180deg,#EF4444,#B91C1C)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 14, flexShrink: 0 }}>{i + 1}</div>
                    <div className="icon-tile" style={{ width: 40, height: 40, borderRadius: 10, flexShrink: 0 }}>
                      <s.icon size={18} />
                    </div>
                  </div>
                  <h3 className="font-serif reg-step-title">{s.title}</h3>
                  <p className="reg-step-desc">{s.desc}</p>
                </div>
              </TiltCard>
            ))}
          </div>
        </div>
      </section>

      <section style={{ padding: "20px 24px 60px" }}>
        <div style={{ maxWidth: 1300, margin: "0 auto" }}>
          <SectionTitle>Registration &amp; Fee Payment Links</SectionTitle>
          <div className="table-scroll"><table className="premium-table" data-testid="admissions-table">
            <thead>
              <tr>
                <th>College Name</th>
                <th>Student Registration</th>
                <th>Fee Payment</th>
              </tr>
            </thead>
            <tbody>
              {colleges.map(c => {
                const active = !c.registerLink.startsWith("#");
                return (
                  <tr key={c.slug}>
                    <td style={{ fontWeight: 600 }}>{c.name}</td>
                    <td>
                      {active ? (
                        <a href={c.registerLink} target="_blank" rel="noreferrer" style={{ color: "#EA580C", textDecoration: "none", fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 6 }}>
                          Register Online <ExternalLink size={12} />
                        </a>
                      ) : (
                        <span className="badge badge-orange">Coming Soon</span>
                      )}
                    </td>
                    <td>
                      {active ? (
                        <a href={c.payLink} target="_blank" rel="noreferrer" data-testid={`pay-fee-${c.slug}`} style={{ color: "#EA580C", textDecoration: "none", fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 6 }}>
                          Pay Fee <ExternalLink size={12} />
                        </a>
                      ) : (
                        <span className="badge badge-orange">Coming Soon</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table></div>
          <div style={{ marginTop: 22, padding: 16, background: "#FEF2F2", border: "1px solid rgba(220,38,38,0.25)", borderLeft: "5px solid #DC2626", borderRadius: 12, display: "flex", alignItems: "flex-start", gap: 10, color: "#B91C1C", fontSize: 13.5, fontWeight: 500 }}>
            <CheckCircle2 size={18} style={{ flexShrink: 0, marginTop: 1 }} />
            <div>Active links open the secure partner portal in a new tab — registrations and payments are not processed on this website. Please retain your registration and payment acknowledgements.</div>
          </div>
        </div>
      </section>
      <style>{`
        .reg-step-body { padding: 20px 16px 16px; display: flex; flex-direction: column; height: 100%; }
        .reg-step-title { font-size: 16px; color: #1C1917; font-weight: 700; line-height: 1.3; min-height: 2.6em; margin: 0; }
        .reg-step-desc { color: #44403C; font-size: 13.5px; margin: 6px 0 0; line-height: 1.45; flex: 1; }
        @media (max-width: 640px) {
          .reg-step-body { padding: 16px 12px 14px; }
          .reg-step-title { font-size: 14.5px; }
          .reg-step-desc { font-size: 12.5px; }
        }
      `}</style>
    </div>
  );
}
